<template>
  <div>
    <v-dialog
      v-model="is_show"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Modifica Questionario</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            @submit.prevent="editSurvey"
          >
            <v-row class="ma-0">
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="localSurveyData.title"
                  label="Titolo"
                  outlined
                  required
                  dense
                  :rules="[formRules.required]"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="localSurveyData.description"
                  label="Descrizione"
                  rows="3"
                  dense
                  outlined
                ></v-textarea>
              </v-col>
              <v-col
                cols="12"
              >
                <v-select
                  v-model="localSurveyData.priority"
                  :items="priorityOpts"
                  label="Priorità"
                  outlined
                ></v-select>
              </v-col>
              <v-col
                cols="12"
              >
                <v-select
                  v-model="localSurveyData.company_status_id"
                  :items="companySettingsFilteredList('survey.status').map(sta => ({ text: sta.name, value: sta.id }))"
                  value="1"
                  label="Stato"
                  outlined
                  :rules="[formRules.required]"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn
                  class="ma-2"
                  :disabled="loading"
                  @click="closeModal"
                >
                  Chiudi
                </v-btn>
                <v-btn
                  color="primary"
                  class="ma-2"
                  :loading="loading"
                  @click.prevent="editSurvey"
                >
                  Salva
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'EditSurvey',
  props: {
    is_show: {
      type: Boolean,
      default: false,
    },
    surveyData: Object,
  },
  data() {
    return {
      form: {},
      priorityOpts: [
        {
          text: 'Normale',
          value: 'standard',
        },
        {
          text: 'Bassa priorità',
          value: 'low',
        },
        {
          text: 'Urgente',
          value: 'high',
        },
      ],
      localSurveyData: {},
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['formRules', 'companySettingsFilteredList']),
  },
  watch: {
    is_show(newShow) {
      if (newShow) {
        this.localSurveyData = JSON.parse(JSON.stringify(this.surveyData))
      }
    },
  },
  methods: {
    async editSurvey() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true
          await this.$api.editSurvey(this.surveyData.procedure_id, this.surveyData.id, this.localSurveyData)
          this.$emit('reload-data')
          this.$store.dispatch('set_alert', { msg: 'Questionario Modificato con successo', type: 'success' })
          this.closeModal()
        } catch (e) {
          this.loading = false
          this.$store.dispatch('set_alert', { msg: 'error', type: 'error' })
        }
      }
    },
    closeModal() {
      this.$emit('close')
      this.loading = false
    },
  },
}
</script>

<style scoped>

</style>
